import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElButton = _resolveComponent("ElButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("textarea", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.content = $event))
    }, null, 512), [
      [_vModelText, _ctx.content]
    ]),
    _createVNode(_component_ElButton, { onClick: _ctx.save }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}